<template>
  <div class="flex w-72 flex-col gap-2 p-3">
    <select
      v-model="maintenanceFilterType"
      :aria-label="$t('W: Filtrer efter type')"
      class="w-full rounded-md border border-border-subtle bg-surface px-2 py-1.5 text-sm">
      <option
        v-for="opt in typeOptions"
        :key="opt.value"
        :value="opt.value">
        {{ opt.text }}
      </option>
    </select>

    <select
      v-model="maintenanceFilterName"
      :aria-label="$t('W: Filtrer efter navn')"
      class="w-full rounded-md border border-border-subtle bg-surface px-2 py-1.5 text-sm">
      <option
        v-for="opt in nameOptions"
        :key="opt.value"
        :value="opt.value">
        {{ opt.text }}
      </option>
    </select>

    <UiInputDateRangePickerVee
      name="maintenanceDateRange"
      :placeholder="$t('area.lab-equipment.maintenance.filter.select-period')"
      :dateFormat="(date: Date) => $d(date, 'shortMonthDate')"
      v-model="maintenanceDateRange" />

    <UiBaseButton
      v-if="hasActiveFilters"
      :text="$t('area.lab-equipment.maintenance.action.reset-filters')"
      theme="neutral"
      @button-click="resetFilters" />
  </div>
</template>

<script lang="ts">
import { useLabEquipmentStore } from '@/stores/labEquipmentStore'
import { useAppStore } from '@/stores/appStore'
import { mapState, mapWritableState } from 'pinia'

export default {
  name: 'LabEquipmentMaintenanceFilterMenu',

  emits: ['close'],

  computed: {
    ...mapState(useLabEquipmentStore, ['labEquipment', 'labEquipmentMaintenance']),
    ...mapState(useAppStore, ['currentLocale']),
    ...mapWritableState(useLabEquipmentStore, [
      'maintenanceFilterType',
      'maintenanceFilterName',
      'maintenanceDateRange',
    ]),

    distinctTypes(): string[] {
      return [
        ...new Set(
          this.labEquipmentMaintenance.map((x) =>
            this.labEquipment.find((eq) => eq.id === x.labEquipmentID)?.getType(this.currentLocale)
          )
        ),
      ]
        .filter((v): v is string => Boolean(v))
        .sort()
    },

    distinctNames(): string[] {
      return [
        ...new Set(
          this.labEquipmentMaintenance.map((x) =>
            this.labEquipment.find((eq) => eq.id === x.labEquipmentID)?.getName(this.currentLocale)
          )
        ),
      ]
        .filter((v): v is string => Boolean(v))
        .sort()
    },

    typeOptions(): { value: string; text: string }[] {
      return [
        {
          value: '',
          text: this.$t('area.lab-equipment.maintenance.filter.all-types'),
        },
        ...this.distinctTypes.map((x) => ({ value: x, text: x })),
      ]
    },

    nameOptions(): { value: string; text: string }[] {
      return [
        {
          value: '',
          text: this.$t('area.lab-equipment.maintenance.filter.all-equipment'),
        },
        ...this.distinctNames.map((x) => ({ value: x, text: x })),
      ]
    },

    hasActiveFilters(): boolean {
      return (
        !!this.maintenanceFilterType ||
        !!this.maintenanceFilterName ||
        this.maintenanceDateRange[0] !== null ||
        this.maintenanceDateRange[1] !== null
      )
    },
  },

  methods: {
    resetFilters() {
      const store = useLabEquipmentStore()
      store.maintenanceFilterType = ''
      store.maintenanceFilterName = ''
      store.maintenanceDateRange = [null, null]
    },
  },
}
</script>
